/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-toastr';
import * as i2 from '@angular/common';
export const ToastContainerModuleNgFactory:i0.NgModuleFactory<i1.ToastContainerModule> = i0.ɵcmf(i1.ToastContainerModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,([] as any[])],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(512,
          i1.ToastContainerModule,i1.ToastContainerModule,([] as any[]))]);
    });
export const ToastrModuleNgFactory:i0.NgModuleFactory<i1.ToastrModule> = i0.ɵcmf(i1.ToastrModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[ToastNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,
          i2.NgLocalization,i2.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(512,i2.CommonModule,
          i2.CommonModule,([] as any[])),i0.ɵmpd(512,i1.ToastrModule,i1.ToastrModule,
          [[3,i1.ToastrModule]])]);
    });
const styles_Toast:any[] = ([] as any[]);
export const RenderType_Toast:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_Toast,
    data:{'animation':[{type:7,name:'flyInOut',definitions:[{type:0,name:'inactive',
        styles:{type:6,styles:{display:'none',opacity:0},offset:(null as any)},options:(undefined as any)},
        {type:0,name:'active',styles:{type:6,styles:{opacity:1},offset:(null as any)},
            options:(undefined as any)},{type:0,name:'removed',styles:{type:6,styles:{opacity:0},
            offset:(null as any)},options:(undefined as any)},{type:1,expr:'inactive => active',
            animation:{type:4,styles:(null as any),timings:'300ms ease-in'},options:(null as any)},
        {type:1,expr:'active => removed',animation:{type:4,styles:(null as any),timings:'300ms ease-in'},
            options:(null as any)}],options:{}}]}});
function View_Toast_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'toast-close-button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.remove()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n    ×\n  ']))],
      (null as any),(null as any));
}
function View_Toast_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      [[8,'className',0],[1,'aria-label',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['\n    ','\n  ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.options.titleClass,'');
        const currVal_1:any = _co.title;
        _ck(_v,0,0,currVal_0,currVal_1);
        const currVal_2:any = _co.title;
        _ck(_v,1,0,currVal_2);
      });
}
function View_Toast_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      [[8,'className',0],[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.options.messageClass,'');
    const currVal_1:any = _co.message;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
function View_Toast_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      [[8,'className',0],[1,'aria-label',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['\n    ','\n  ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.options.messageClass,
            '');
        const currVal_1:any = _co.message;
        _ck(_v,0,0,currVal_0,currVal_1);
        const currVal_2:any = _co.message;
        _ck(_v,1,0,currVal_2);
      });
}
function View_Toast_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),
      0,'div',[['class','toast-progress']],[[4,'width','%']],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.width;
        _ck(_v,2,0,currVal_0);
      });
}
export function View_Toast_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_Toast_1)),i0.ɵdid(2,16384,(null as any),
      0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_Toast_2)),i0.ɵdid(5,16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_Toast_3)),i0.ɵdid(8,16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_Toast_4)),i0.ɵdid(11,16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_Toast_5)),i0.ɵdid(14,16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:i1.Toast = _v.component;
    const currVal_0:any = _co.options.closeButton;
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = _co.title;
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = (_co.message && _co.options.enableHtml);
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = (_co.message && !_co.options.enableHtml);
    _ck(_v,11,0,currVal_3);
    const currVal_4:any = _co.options.progressBar;
    _ck(_v,14,0,currVal_4);
  },(null as any));
}
export function View_Toast_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['toast-component',
      '']],[[8,'className',0],[40,'@flyInOut',0]],[[(null as any),'click'],[(null as any),
      'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,1).tapToast()) !== false);
      ad = (pd_0 && ad);
    }
    if (('mouseenter' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,1).stickAround()) !== false);
      ad = (pd_1 && ad);
    }
    if (('mouseleave' === en)) {
      const pd_2:any = ((<any>i0.ɵnov(_v,1).delayedHideToast()) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },View_Toast_0,RenderType_Toast)),i0.ɵdid(1,180224,(null as any),0,i1.Toast,[i1.ToastrService,
      i1.ToastPackage,i0.ApplicationRef],(null as any),(null as any))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,1).toastClasses;
        const currVal_1:any = i0.ɵnov(_v,1).state;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
export const ToastNgFactory:i0.ComponentFactory<i1.Toast> = i0.ɵccf('[toast-component]',
    i1.Toast,View_Toast_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/$$_gendir/~/ngx-toastr/index.ngfactory.ts